window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Class to detect hybrid devices.
 * Automatically instantiated in o_global.device.hybrid namespace.
 */
function Hybrid() {
    "use strict";

    var _storage = new o_global.Storage(function() {
            return window.sessionStorage;
        }),
        _isTouchable = !!o_global.device.isTouchable,
        _mouseMoveCounter = 0,
        _checkCounter = 0,
        _timeoutIdArr = [],
        _self = this;

    this.isDetected = false;
    this.callbackList = [];

    /**
     * Initialize hybrid detection by monitoring mousemove events.
     * This check will only run once a session. Positive result is saved in SessionStorage.
     *
     * @private
     */
    function _initHybridDetection() {
        if (_isTouchable) {
            if (_storage.getItem("isHybrid") === "true") {
                _self.isDetected = true;
            } else if (!_storage.getItem("isHybrid")) {  // Only check once a session, if hybrid is not detected, value is set to false
                o_global.eventLoader.onReady(200, function() {
                    document.documentElement.addEventListener("mousemove", _checkMouseMoves);
                });
            }
        }
    }

    /**
     * _checkMouseMoves()
     * Function is called by mousemove events to find out if it is a hybrid device by counting mousemove-calls
     *
     * @private
     */
    function _checkMouseMoves() {
        var timeoutId;

        if (_mouseMoveCounter++ > 2) {
            _updateStatus();
            document.documentElement.removeEventListener("mousemove", _checkMouseMoves);
        }

        // Reset mouseMoveCounter after a certain time, because touch devices might fire mousemove-events as well
        if (!_self.isDetected) {
            timeoutId = setTimeout(function() {
                _mouseMoveCounter = 0;
                if (_checkCounter++ > 8) {
                    _storage.setItem("isHybrid", false);
                    document.documentElement.removeEventListener("mousemove", _checkMouseMoves);
                }
            }, 300);
            _registerTimeout(timeoutId);
        }
    }

    /**
     * Function to clear all timeouts that are stored in _timeoutIdArr.
     *
     * @private
     */
    function _clearTimeouts() {
        while (_timeoutIdArr.length > 0) {
            clearTimeout(_timeoutIdArr.pop());
        }
    }

    /**
     * Timeout Id is stored in _timeoutIdArr
     *
     * @param {Number} timeoutId A Number representing the ID value of the timer that is set
     * @private
     */
    function _registerTimeout(timeoutId) {
        _timeoutIdArr.push(timeoutId);
    }

    /**
     * Called if hybrid is detected.
     * Stores hybrid values and informs registered objects.
     *
     * @private
     */
    function _updateStatus() {
        _clearTimeouts();
        _storage.setItem("isHybrid", true);
        _self.isDetected = true;

        for (var i = 0; i < _self.callbackList.length; i++) {
            _self.callbackList[i]();
        }
    }

    _initHybridDetection();
}

/**
 * Objects that want to get informed by hybrid detection must be registrated by calling this function.
 * Example see: o_global.pali.tooltipHandler
 *
 * @param {Function} callback Function to be called after hybrid tests where successful.
 */
Hybrid.prototype.executeOrRegisterCallback = function(callback) {
    "use strict";

    if (this.isDetected) {
        callback();
    } else {
        this.callbackList.push(callback);
    }
};

// Intialize a default object with the default breakpoints.
o_global.device.hybrid = new Hybrid();
